module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/277cf108a773b6a4aa2c3b73c33d8227.png";